import { objectHasProps } from "frontend/components/helpers/index.js";

const hasTnpEmailCheck = email => {
    return !!email && email.includes("thenounproject.com");
};

const userHasAccessCheck = (myModProfile, shouldBeManager = false) => {
    // must have a moderator profile with props
    if (!myModProfile || !objectHasProps(myModProfile)) {
        return false;
    }

    const { isManager } = myModProfile;

    // Should they also be a manager?
    return shouldBeManager ? isManager : true;
};

export const hasAccessCheck = ({
    isLoggedIn,
    currentUser = {},
    myModProfile
}) => {
    const { email } = currentUser;
    const hasTnpEmail = hasTnpEmailCheck(email);
    const hasAccess = userHasAccessCheck(myModProfile);
    return isLoggedIn && hasTnpEmail && hasAccess;
};
